/* Zivaria top bar: rotating messages + country drawer */
(() => {
  const timers = new WeakMap();

  const initBar = (bar) => {
    const track = bar.querySelector('[data-zv-annc-track]');
    if (track && !timers.has(track)) {
      const msgs = [...track.querySelectorAll('.zv-annc__msg')];
      if (msgs.length > 1) {
        let i = 0;
        let paused = false;
        const interval = Number(track.dataset.interval) || 4000;
        track.addEventListener('mouseenter', () => (paused = true));
        track.addEventListener('mouseleave', () => (paused = false));
        track.addEventListener('focusin', () => (paused = true));
        track.addEventListener('focusout', () => (paused = false));
        const id = setInterval(() => {
          if (paused || document.hidden) return;
          const cur = msgs[i];
          i = (i + 1) % msgs.length;
          const next = msgs[i];
          cur.classList.remove('is-active');
          cur.classList.add('is-leaving');
          cur.setAttribute('aria-hidden', 'true');
          setTimeout(() => cur.classList.remove('is-leaving'), 500);
          next.classList.add('is-active');
          next.removeAttribute('aria-hidden');
        }, interval);
        timers.set(track, id);
      }
    }
  };

  const initDrawer = (dialog) => {
    if (dialog.dataset.zvReady) return;
    dialog.dataset.zvReady = '1';
    const form = dialog.querySelector('[data-zv-ship-form]');
    const search = dialog.querySelector('[data-zv-ship-search]');
    const items = [...dialog.querySelectorAll('[data-zv-ship-list] > li')];
    const empty = dialog.querySelector('[data-zv-ship-empty]');

    dialog.querySelector('[data-zv-ship-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

    search?.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      let shown = 0;
      items.forEach((li) => {
        const hit = !q || li.dataset.name.includes(q);
        li.hidden = !hit;
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });

    dialog.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-country]');
      if (opt && form) {
        form.querySelector('[data-zv-country-input]').value = opt.dataset.country;
        form.submit();
        return;
      }
      const lang = e.target.closest('[data-language]');
      if (lang && form) {
        form.querySelector('[data-zv-language-input]').value = lang.dataset.language;
        form.submit();
      }
    });
  };

  const start = () => {
    document.querySelectorAll('[data-zv-annc]').forEach(initBar);
    document.querySelectorAll('[data-zv-ship]').forEach(initDrawer);
  };

  if (!window.__zvAnnc) {
    window.__zvAnnc = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-zv-annc-open]');
      if (!btn) return;
      const dialog = document.getElementById(btn.getAttribute('aria-controls'));
      if (!dialog) return;
      initDrawer(dialog);
      dialog.showModal();
      const sel = dialog.querySelector('[aria-selected="true"]');
      sel?.scrollIntoView({ block: 'center' });
      dialog.querySelector('[data-zv-ship-search]')?.focus();
    });
    document.addEventListener('shopify:section:load', start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
